import { Routes } from '@angular/router';
import { PermissionGuard } from '../security/permission.guard';
import { app_permissions } from '../security/app-permissions';
import { FieldWorkPackageDetailComponent } from './field-work-package-detail.component';
import { FieldWorkWorkbenchComponent } from './field-work-workbench.component';
import { FieldWorkLaborRatesRedirectComponent } from './field-work-labor-rates-redirect.component';

export const fieldWorkRoutes: Routes = [
  { path: 'operations/field-work', pathMatch: 'full', redirectTo: 'operations/field-work/work-packages' },
  {
    path: 'operations/field-work/work-packages',
    component: FieldWorkWorkbenchComponent,
    canActivate: [PermissionGuard],
    data: { permission: app_permissions.operations.fieldWork.view, fieldWorkPage: 'packages' }
  },
  {
    path: 'operations/field-work/work-packages/:id',
    component: FieldWorkPackageDetailComponent,
    canActivate: [PermissionGuard],
    data: { permission: app_permissions.operations.fieldWork.view }
  },
  {
    path: 'operations/field-work/people',
    component: FieldWorkWorkbenchComponent,
    canActivate: [PermissionGuard],
    data: { permission: app_permissions.operations.fieldWork.view, fieldWorkPage: 'people' }
  },
  {
    path: 'operations/field-work/setup',
    component: FieldWorkWorkbenchComponent,
    canActivate: [PermissionGuard],
    data: { permission: app_permissions.operations.fieldWork.view, fieldWorkPage: 'setup' }
  },
  {
    path: 'operations/field-work/schedule',
    component: FieldWorkWorkbenchComponent,
    canActivate: [PermissionGuard],
    data: { permission: app_permissions.operations.fieldWork.view, fieldWorkPage: 'schedule' }
  },
  {
    path: 'operations/field-work/assignments',
    component: FieldWorkWorkbenchComponent,
    canActivate: [PermissionGuard],
    data: { permission: app_permissions.operations.fieldWork.view, fieldWorkPage: 'assignments' }
  },
  {
    path: 'operations/field-work/approvals',
    component: FieldWorkWorkbenchComponent,
    canActivate: [PermissionGuard],
    data: { permission: app_permissions.operations.fieldWork.view, fieldWorkPage: 'approvals' }
  },
  {
    path: 'operations/field-work/equipment',
    component: FieldWorkWorkbenchComponent,
    canActivate: [PermissionGuard],
    data: { permission: app_permissions.operations.equipment.view, fieldWorkPage: 'equipment' }
  },
  {
    path: 'operations/field-work/labor/rate-cards',
    component: FieldWorkLaborRatesRedirectComponent
  },
  {
    path: 'operations/field-work/equipment/rate-cards',
    component: FieldWorkWorkbenchComponent,
    canActivate: [PermissionGuard],
    data: { permission: app_permissions.operations.equipment.ratesView, fieldWorkPage: 'rates' }
  },
  {
    path: 'operations/field-work/finance-exceptions',
    component: FieldWorkWorkbenchComponent,
    canActivate: [PermissionGuard],
    data: { permission: app_permissions.operations.fieldWork.financeView, fieldWorkPage: 'exceptions' }
  }
];
